export const defaultSeoMeta = {
  siteName: "Swiftspace",
  description: "",
};

export const footerText = "© Swiftspace. All rights reserved.";

export const unitSystems = new Map([
  ["metric", { name: "Metric", lengthUnit: "m", areaUnit: "m²" }],
  ["imperial", { name: "Imperial", lengthUnit: "ft", areaUnit: "ft²" }],
]);

export const dataSources = new Map([
  ["figma", { label: "Locked", icon: "lock-closed" }],
  ["rainfocus", { label: "Locked", icon: "lock-closed" }],
  ["database", { label: "Editable", icon: "pencil" }],
  ["extern", { label: "Synchronized", icon: "link" }],
]);

export const boothFields = new Map([
  ["name", { label: "Booth Number", type: "string", source: "figma" }],
  ["displayName", { label: "Display Name", type: "string", source: "figma" }],
  ["sponsorLevel", { label: "Sponsor Level", type: "string", source: "figma" }],
  ["dimensions", { label: "Dimensions", type: "string", source: "figma" }],
  ["area", { label: "Area", type: "string", source: "figma" }],
  ["boothId", { label: "RF ID", type: "string", source: "rainfocus" }],
  ["figmaId", { label: "Code", type: "string", source: "figma" }],
  [
    "exhibitorName",
    { label: "Sponsor Name", type: "string", source: "extern" },
  ],
  ["isBlocked", { label: "Blocked", type: "boolean", source: "database" }],
  [
    "overrideDisplayName",
    { label: "Override Name", type: "string", source: "database" },
  ],
  ["notes", { label: "Notes", type: "text", source: "database" }],
  [
    "hideDisplayName",
    { label: "Hide Name", type: "boolean", source: "database" },
  ],
]);
